import { Trans } from 'react-i18next';

import { StrongText } from '@dreryk/react-components';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import { extendedDosageTemplatesTranslationKeys } from '../../../../translations';

import { DosageTemplateListItem, DosageTemplateUse } from './DosageTemplates.types';

type DosageTemplatesUseTemplateModalConfirmButtonProps = {
   readonly shouldConfirm: boolean;
   readonly onClick: DosageTemplateUse;
};

export const DosageTemplatesUseTemplateModalConfirmButton = (
   props: DosageTemplatesUseTemplateModalConfirmButtonProps
): JSX.Element => {
   return (
      <FormsTemplates.UseTemplateModalConfirmButton<DosageTemplateListItem>
         onClick={props.onClick}
         confirmationText={
            props.shouldConfirm ? (
               <Trans
                  i18nKey={extendedDosageTemplatesTranslationKeys.areYouSureUsingTemplate}
                  components={{ strong: <StrongText testId={'useTemplate'} /> }}
               />
            ) : undefined
         }
      />
   );
};
